// extracted by mini-css-extract-plugin
module.exports = {"estateList":"EstateList_estateList__iZIJ0","estateChip":"EstateList_estateChip__1-vM6"};